import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Search, HelpCircle, Sparkles } from "lucide-react";
import { resetTour } from "@/components/CoachTip";
import { toast } from "sonner";

const FAQS = [
  { q: "What does UNALLOCATED mean?", a: "Your worked kilos don't yet match the kilos allocated to product codes. Use step 4 of the wizard and tap 'Auto-fill remaining' to balance the pile." },
  { q: "How is a worker's earned kg calculated?", a: "Pool workers split the pile by minutes: (their minutes ÷ total pool minutes) × pool kgs. Bucket workers = buckets × that weekday's bucket weight. Direct = the kg you typed. Piece is dollars only, no kg." },
  { q: "Which shift do I pick for an 11pm Sunday start?", a: "The 1st (Night) shift. A shift always counts toward its start date, so an 11pm Sunday shift belongs to Sunday." },
  { q: "Can I fix a mistake after filing?", a: "Yes — open My Log, tap Edit, then tap a reason (Added kilos, Added products, Balanced, Added worker, Changed date) or type your own. Nothing is ever deleted; every change is appended to the audit trail for the 7-year Fair Work record." },
  { q: "Why can't I see dollar figures?", a: "Supervisors work in kilos only. Pricing and production value are admin-only and enforced on the server." },
  { q: "Do photos have to be attached?", a: "No, photos are optional. Attach them as evidence when helpful — they appear in the dashboard product drill-down." },
  { q: "What is the Weekly Product Tally?", a: "It's a charge-out reference of total kg per product for the week. There is no invoicing in the app." },
  { q: "My entry says CHECK DATA — why?", a: "Something looks off, e.g. pool workers have zero total minutes, or a negative number was entered. Review the workers step." },
];

export default function FAQ() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const filtered = FAQS.filter((f) => (f.q + f.a).toLowerCase().includes(q.toLowerCase()));
  const replayTour = () => { resetTour(); toast.success("Tour reset — opening the dashboard"); navigate("/dashboard"); };
  return (
    <div className="p-4 md:p-6 space-y-4 max-w-2xl">
      <div className="flex items-start justify-between gap-2">
        <div><h1 className="font-heading font-extrabold text-3xl tracking-tight text-slate-800 flex items-center gap-2"><HelpCircle strokeWidth={2.5} /> FAQ</h1><p className="text-slate-500 text-sm">Supervisor troubleshooting</p></div>
        <Button data-testid="replay-tour" onClick={replayTour} variant="outline" className="gap-1.5 rounded-full border-teal-200 text-teal-700 whitespace-nowrap"><Sparkles size={15} strokeWidth={2.5} /> Replay tour</Button>
      </div>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
        <Input data-testid="faq-search" placeholder="Search help…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-10 h-12" />
      </div>
      <Accordion type="single" collapsible className="bg-white rounded-md border border-border px-4">
        {filtered.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`}>
            <AccordionTrigger className="font-heading font-semibold text-slate-800 text-left">{f.q}</AccordionTrigger>
            <AccordionContent className="text-slate-600">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
        {filtered.length === 0 && <div className="py-6 text-slate-400 text-sm text-center">No matching help articles.</div>}
      </Accordion>
    </div>
  );
}
